import { useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { readSkippedHotelsFromRouteState } from "component/quotation/duplicateQuotationSkippedHotelsUtil"

/**
 * Hotel Availability Update popup state for the preview page, read from the router state set by
 * the duplicate flow. Close clears that state so back/refresh does not show it again.
 * `isReady` holds the popup back until the new quotation's preview has loaded.
 */
const useDuplicateSkippedHotelsNotice = (isReady: boolean) => {

    const location = useLocation()
    const navigate = useNavigate()
    const skippedHotels = useMemo(() => readSkippedHotelsFromRouteState(location.state), [location.state])

    const onClose = () => {
        navigate(
            { pathname: location.pathname, search: location.search, hash: location.hash },
            { replace: true, state: null },
        )
    }

    return {
        isOpen: isReady && skippedHotels.length > 0,
        skippedHotels,
        onClose,
    }
}

export default useDuplicateSkippedHotelsNotice
